import { createSelector } from "reselect";
import getProfessionFieldsSelector from "./getProfessionFieldsSelector";
import getProfessionTitleSelector from "./getProfessionTitleSelector";

export default createSelector(
    getProfessionFieldsSelector,
    getProfessionTitleSelector,
    (_: Store, field: string | any) => field,
    (fields: GenericObject | any, title, field) => {
        if ((field as any) === "post_title") {
            return title;
        }
        return fields[field];
    }
);
